// @source https://gitlab.iris-interactive.fr/wordpress/otvaldegaronne/theme_customer_otvaldegaronne/-/blob/master/resources/assets/scripts/components/map-home.component.js
export default class MapHomeComponent {
    static isAjaxRunning = false

    constructor() {
        if ($('.strate--carto').length > 0) {
            MapHomeComponent.onDesktop()

            if (window.matchMedia('(max-width: 1000px)').matches) {
                window.addEventListener('resize', MapHomeComponent.onDesktop)
            }
        }
    }

    static onDesktop() {
        if (window.matchMedia('(min-width: 1000px)').matches) {
            window.removeEventListener('resize', MapHomeComponent.onDesktop)

            const mapWrapper = '[data-element="svg-map"]'

            $.ajax({
                url: IRISCollectionCustomer.ajaxUrl,
                type: 'post',
                data: {
                    action: 'get_svg_map_home',
                },
                success: (result) => {
                    $(mapWrapper).fadeOut(250, () => {
                        $('.strate--carto').removeClass('loading')
                        $(mapWrapper).html(result)
                        $(mapWrapper).fadeIn(250)

                        if (!$('body').hasClass('eco-mode-active')) {
                            MapHomeComponent.onClick()
                        }
                    })
                },
            })
        }
    }

    static onClick() {
        const zone = '[data-trigger="color-zone"]'
        let previousActiveZone = ''

        $(zone).on('click', function () {
            const activeZone = $(this).attr('id')

            if (previousActiveZone === activeZone) return
            if (!MapHomeComponent.isAjaxRunning) {
                MapHomeComponent.isAjaxRunning = true
                MapHomeComponent.ajaxContent(activeZone)

                $(zone).removeClass('active')
                $(this).addClass('active')
                previousActiveZone = activeZone
            }
        })
    }

    static ajaxContent(zoneName) {
        const contentWrapper = '[data-element="carto-wrapper"]'
        const mediaWrapper = '[data-element="carto-wrapper__media"]'

        $(contentWrapper).addClass(`ajax-loading ${zoneName}`)

        $.ajax({
            url: IRISCollectionCustomer.ajaxUrl,
            type: 'post',
            data: {
                action: 'get_map_interactive_content',
                zone: zoneName,
            },
            success(result) {
                const resultParsed = JSON.parse(result)

                $(mediaWrapper).html(resultParsed.bgImage)

                $('[data-element="carto-subtitle"]').text(resultParsed.subtitle)
                $('[data-element="carto-description"]').text(resultParsed.description)

                $('[data-element="carto-link"]')
                    .attr('src', resultParsed.link.url)
                    .attr('target', resultParsed.link.target)
                    .text(resultParsed.link.title)

                $(contentWrapper).removeClass(`ajax-loading ${zoneName}`)
                MapHomeComponent.isAjaxRunning = false
            },
            error(error) {
                $(contentWrapper).data('text', '⚠️')
                console.error(error)

                MapHomeComponent.isAjaxRunning = false
            },
        })
    }
}
